import { ioListOptions, ioSaveOption } from '@/febos/servicios/api/herramientas.api';

export async function saveNewProducts({ commit }, payload) {
  try {
    commit('SET_LOADING', true);
    const response = await ioSaveOption(payload.param, payload.body);
    console.log('loadListProducts', response);
    return response;
  } finally {
    commit('SET_LOADING', false);
  }
}

export async function loadListProducts({ commit }, payload) {
  try {
    commit('SET_LOADING', true);
    const response = await ioListOptions(payload);
    commit('SET_LIST_PRODUCTS', response.data);
  } finally {
    commit('SET_LOADING', false);
  }
}
